// src/components/auth/RegisterStep3.jsx

// import React, { useState, useEffect } from "react";
// import { MdMobileFriendly } from "react-icons/md";
// import { useNavigate } from "react-router-dom";

// const RegisterStep3 = () => {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     caste: "",
//     subcaste: "",
//     gothra: "",
//     willingOtherCommunities: false,
//     email: "", // preserve email for consistency
//   });

//   const castes = [
//     "Brahmin", "Kshatriya", "Vaishya", "Shudra", "Rajput", "Maratha",
//     "Reddy", "Yadav", "Jat", "Kayastha", "Khatri", "Agarwal", "Gupta",
//     "Patel", "Kamma", "Kapu", "Ezhava", "Nair", "Vokkaliga", "Lingayat",
//     "Kurmi", "SC", "ST", "OBC", "Other"
//   ];

//   const subcastes = [
//     "Iyengar", "Iyer", "Deshastha", "Madhwa", "Chitpavan", "Other"
//   ];

//   const gothras = [
//     "Bharadwaj", "Kashyapa", "Vasishta", "Gautam", "Agastya", "Atri", "Other"
//   ];

//   useEffect(() => {
//     const savedData = JSON.parse(localStorage.getItem("registrationData"));
//     if (savedData) {
//       setFormData((prev) => ({
//         ...prev,
//         caste: savedData.caste || "",
//         subcaste: savedData.subcaste || "",
//         gothra: savedData.gothra || "",
//         willingOtherCommunities: savedData.willingOtherCommunities || false,
//         email: savedData.email || "",
//       }));
//     }
//   }, []);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const existingData = JSON.parse(localStorage.getItem("registrationData")) || {};
//     const mergedData = { ...existingData, ...formData };
//     localStorage.setItem("registrationData", JSON.stringify(mergedData));
//     navigate("/register-step4");
//   };

//   const handleBack = () => {
//     const existingData = JSON.parse(localStorage.getItem("registrationData")) || {};
//     const mergedData = { ...existingData, ...formData };
//     localStorage.setItem("registrationData", JSON.stringify(mergedData));
//     navigate("/register-step2");
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
//       <div className="bg-white shadow-lg rounded-2xl flex flex-col md:flex-row w-full max-w-4xl overflow-hidden">

//         {/* Left Section */}
//         <div className="md:w-1/2 bg-green-50 flex flex-col justify-center items-center p-8">
//           <MdMobileFriendly className="text-green-600 text-7xl mb-6" />
//           <p className="text-xl md:text-2xl font-semibold text-green-700 text-center">
//             Every profile is mobile-verified to ensure credibility.
//           </p>
//         </div>

//         {/* Right Section */}
//         <div className="md:w-1/2 w-full bg-white p-8 rounded-lg shadow">
//           <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-1">
//             Religion/Caste details help us find better matches
//           </h2>

//           <form onSubmit={handleSubmit} className="space-y-5 mt-4">

//             {/* Caste */}
//             <div>
//               <label className="block text-gray-700 mb-1">Caste</label>
//               <select
//                 name="caste"
//                 value={formData.caste}
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
//                 required
//               >
//                 <option value="">Select</option>
//                 {castes.map((caste) => (
//                   <option key={caste} value={caste}>{caste}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Willing to marry from other communities */}
//             <div className="flex items-center space-x-2">
//               <input
//                 type="checkbox"
//                 name="willingOtherCommunities"
//                 checked={formData.willingOtherCommunities}
//                 onChange={handleChange}
//                 className="accent-green-500"
//               />
//               <label className="text-gray-700">Willing to marry from other communities also</label>
//             </div>

//             {/* Subcaste */}
//             <div>
//               <label className="block text-gray-700 mb-1">
//                 Subcaste <span className="text-gray-400">(Optional)</span>
//               </label>
//               <select
//                 name="subcaste"
//                 value={formData.subcaste}
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
//               >
//                 <option value="">Select</option>
//                 {subcastes.map((sub) => (
//                   <option key={sub} value={sub}>{sub}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Gothra */}
//             <div>
//               <label className="block text-gray-700 mb-1">
//                 Gothra(m) <span className="text-gray-400">(Optional)</span>
//               </label>
//               <select
//                 name="gothra"
//                 value={formData.gothra}
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
//               >
//                 <option value="">Select</option>
//                 {gothras.map((gothra) => (
//                   <option key={gothra} value={gothra}>{gothra}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Button Group */}
//             <div className="flex gap-3 mt-2">
//               <button
//                 type="button"
//                 onClick={handleBack}
//                 className="w-full bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 rounded-lg transition duration-200"
//               >
//                 Back
//               </button>
//               <button
//                 type="submit"
//                 className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 rounded-lg transition duration-200"
//               >
//                 Continue
//               </button>
//             </div>
//           </form>

//           <p className="text-xs text-center text-gray-400 mt-6">
//             Copyright © 2025. All rights reserved.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default RegisterStep3;


import React, { useState, useEffect } from "react";
import { MdMobileFriendly } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const RegisterStep3 = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    caste: "",
    subcaste: "",
    gothra: "",
    willingOtherCommunities: false,
    email: "",
  });

  const [errors, setErrors] = useState({});

  const castes = [
    "Brahmin", "Kshatriya", "Vaishya", "Shudra", "Rajput", "Maratha",
    "Reddy", "Yadav", "Jat", "Kayastha", "Khatri", "Agarwal", "Gupta",
    "Patel", "Kamma", "Kapu", "Ezhava", "Nair", "Vokkaliga", "Lingayat",
    "Kurmi", "SC", "ST", "OBC", "Other"
  ];

  const subcastes = [
    "Iyengar", "Iyer", "Deshastha", "Madhwa", "Chitpavan", "Other"
  ];

  const gothras = [
    "Bharadwaj", "Kashyapa", "Vasishta", "Gautam", "Agastya", "Atri", "Other"
  ];

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("registrationData"));
    if (savedData) {
      setFormData((prev) => ({
        ...prev,
        caste: savedData.caste || "",
        subcaste: savedData.subcaste || "",
        gothra: savedData.gothra || "",
        willingOtherCommunities: savedData.willingOtherCommunities || false,
        email: savedData.email || "",
      }));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
    setErrors({ ...errors, [name]: "" }); // Clear error on change
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.caste) newErrors.caste = "Caste is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    const existingData = JSON.parse(localStorage.getItem("registrationData")) || {};
    const mergedData = { ...existingData, ...formData };
    localStorage.setItem("registrationData", JSON.stringify(mergedData));
    navigate("/register-step4-html");
  };

  const handleBack = () => {
    const existingData = JSON.parse(localStorage.getItem("registrationData")) || {};
    const mergedData = { ...existingData, ...formData };
    localStorage.setItem("registrationData", JSON.stringify(mergedData));
    navigate("/register-step2-html");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white shadow-lg rounded-2xl flex flex-col md:flex-row w-full max-w-4xl overflow-hidden">

        {/* Left Section */}
        <div className="md:w-1/2 bg-green-50 flex flex-col justify-center items-center p-8">
          <MdMobileFriendly className="text-green-600 text-7xl mb-6" />
          <p className="text-xl md:text-2xl font-semibold text-green-700 text-center">
            Every profile is mobile-verified to ensure credibility.
          </p>
        </div>

        {/* Right Section */}
        <div className="md:w-1/2 w-full bg-white p-8 rounded-lg shadow">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-1">
            Religion/Caste details help us find better matches
          </h2>

          <form onSubmit={handleSubmit} className="space-y-5 mt-4">

            {/* Caste */}
            <div>
              <label className="block text-gray-700 mb-1">Caste</label>
              <select
                name="caste"
                value={formData.caste}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
              >
                <option value="">Select</option>
                {castes.map((caste) => (
                  <option key={caste} value={caste}>{caste}</option>
                ))}
              </select>
              {errors.caste && <p className="text-sm text-red-600 mt-1">{errors.caste}</p>}
            </div>

            {/* Willing to marry from other communities */}
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                name="willingOtherCommunities"
                checked={formData.willingOtherCommunities}
                onChange={handleChange}
                className="accent-green-500"
              />
              <label className="text-gray-700">Willing to marry from other communities also</label>
            </div>

            {/* Subcaste */}
            <div>
              <label className="block text-gray-700 mb-1">
                Subcaste <span className="text-gray-400">(Optional)</span>
              </label>
              <select
                name="subcaste"
                value={formData.subcaste}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
              >
                <option value="">Select</option>
                {subcastes.map((sub) => (
                  <option key={sub} value={sub}>{sub}</option>
                ))}
              </select>
            </div>

            {/* Gothra */}
            <div>
              <label className="block text-gray-700 mb-1">
                Gothra(m) <span className="text-gray-400">(Optional)</span>
              </label>
              <select
                name="gothra"
                value={formData.gothra}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
              >
                <option value="">Select</option>
                {gothras.map((gothra) => (
                  <option key={gothra} value={gothra}>{gothra}</option>
                ))}
              </select>
            </div>

            {/* Buttons */}
            <div className="flex gap-3 mt-2">
              <button
                type="button"
                onClick={handleBack}
                className="w-full bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 rounded-lg transition duration-200"
              >
                Back
              </button>
              <button
                type="submit"
                className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 rounded-lg transition duration-200"
              >
                Continue
              </button>
            </div>
          </form>

          <p className="text-xs text-center text-gray-400 mt-6">
            Copyright © 2025. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterStep3;
